import { combineReducers } from 'redux';

import featuredShowsReducer, { FeaturedShow } from './featuredShowsReducer';
import heroReducer, { HeroState } from './heroReducer';
import metadataReducer, { Metadata } from './metadataReducer';
import showsReducer, { Show } from './showsReducer';
import uiReducer, { UIState } from './uiReducer';

export {
    FeaturedShow,
    HeroState,
    Metadata,
    Show,
    UIState,
};

export interface ShowsIndexState {
    featuredShows: FeaturedShow[];
    hero: HeroState;
    metadata: Metadata;
    shows: Show[];
    ui: UIState;
}

export default combineReducers<ShowsIndexState>({
    featuredShows: featuredShowsReducer,
    hero: heroReducer,
    metadata: metadataReducer,
    shows: showsReducer,
    ui: uiReducer,
});
